


<div class="intro-area pd-top-120">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-xl-7 col-lg-8">
                <div class="section-title text-center">
                    <h1>FSI Course Application - Study on the move</h1>
                    <p>Making the FSI courses easier to use. Be one of the first <b>BETA</b> users and register.</p>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="banner-area">
    <div class="container">
        <div class="banner-area-inner" style="background-image:url('assets/img/banner/latin-american-spanish.jpg')">
            <div class="row" *ngIf="successfullySignup != true">
                <div class="col-xl-5 col-lg-7 col-md-10">
                    <div class="banner-inner">
                        <form [formGroup]="signupForm" (ngSubmit)="onSubmitSignup(signupForm.value)" _lpchecked="1">
                            <h2>Register an account</h2>
                            <p style="color:#fff">Free to try out. Register today.</p>
                            <div *ngIf="emailExists" style="margin-top:16px;">
                                <p style="color:#fff">That email already has an account.</p>
                            </div>
                            <div *ngIf="invalidEmail" style="margin-top:16px;">
                                <p style="color:#fff">You need to supply a valid email address.</p>
                            </div>  
                            <div class="main-search-inner">
                                <i class="fa fa-envelope"></i>
                                <input [attr.disabled]="processing ? '' : null" required type="text" placeholder="Email" formControlName="email">
                            </div>
                            <div *ngIf="!validPassword" style="margin-top:16px;">
                                <p style="color:#fff">Passwords must be 8 or more characters in length, contain an uppercase character and a number.</p>
                            </div>                            
                            <div class="main-search-inner">
                                <i class="fa fa-unlock-alt"></i>
                                <input [attr.disabled]="processing ? '' : null" required type="password" placeholder="Password" formControlName="password">                            
                            </div>
                            <div class="main-search-inner" style="text-align: center;">
                                <button [disabled]="processing" type="submit" class="btn btn-white log-in" ng-reflect-router-link="/account" href="/account">Sign me up</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="successfullySignup == true">
                <div class="col-xl-5 col-lg-7 col-md-10">
                    <div class="banner-inner">
                        <h2>Account created - Please login</h2>                       
                        <p *ngIf="!confirmationCodeSuccess" style="color:#fff">Redirecting you to the login page.</p>                                                                   
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="intro-area pd-top-120">
    <div class="container">                
        <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6">
                <div class="single-intro-inner text-center">
                    <div class="thumb">
                        <img src="assets/img/icon/smartphone.png" style="width:80px" alt="img">
                    </div>
                    <div class="details">
                        <h5>Learn on the move! Smartphone friendly</h5>
                        <p>Courses designed to work specifically on <u><b>mobile</b></u>, <u><b>tablet</b></u> and <u><b>desktop</b></u>.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-intro-inner text-center">
                    <div class="thumb">
                        <img src="assets/img/icon/no-downloads.png" style="width:80px" alt="img">
                    </div>
                    <div class="details">
                        <h5>No more downloads, no more pdfs</h5>
                        <p>Start learning right away - <u><b>no downloads</b></u>, <u><b>no audio files</b></u> to mess with.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-intro-inner text-center">
                    <div class="thumb">
                        <img src="assets/img/icon/record-progress.png" style="width:80px" alt="img">
                    </div>
                    <div class="details">
                        <h5>Record your progress</h5>
                        <p><u><b>Auto save progress</b></u> - no need to remember pages or audio files.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="intro-area pd-top-120">
    <div class="container">        
        <div class="row justify-content-center">
            <div class="col-xl-7 col-lg-8">
                <div class="section-title text-center">
                    <h2>FSI Course Application</h2>
                    <p>Making the foreign service institute courses more <u><b>intuitive</b></u>, <u><b>accessible</b></u> and <u><b>better</b></u>.</p>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">            
            <div class="col-lg-4 col-md-6">
                <div class="single-intro-inner text-center">
                    <div style="margin-bottom: 30px;" class="details">
                        <h5>Audio tracking</h5>
                        <p>Each page's audio plays from correct position.</p>
                    </div>
                    <div class="thumb">
                        <img src="assets/img/screens/sound-progress.jpg" style="border: #2A2A2A solid 8px;border-radius: 15px;" alt="img">
                    </div>                    
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-intro-inner text-center">
                    <div style="margin-bottom: 30px;" class="details">
                        <h5>Zoom the content</h5>
                        <p>Tap the screen to read small text.</p>
                    </div>
                    <div class="thumb">
                        <img src="assets/img/screens/zoom-into-content.jpg" style="border: #2A2A2A solid 8px;border-radius: 15px;" alt="img">
                    </div>                    
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="single-intro-inner text-center">
                    <div style="margin-bottom: 30px;"  class="details">
                        <h5>Intuitive usage</h5>
                        <p>Scroll between pages. Lightbulb gives tips</p>
                    </div>
                    <div class="thumb">
                        <img src="assets/img/screens/self-eval-quiz.jpg" style="border: #2A2A2A solid 8px;border-radius: 15px;" alt="img">
                    </div>                    
                </div>
            </div>
        </div>
    </div>
</div>